/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Heading_LabelInputs */

const en_about_heading_label = /** @type {(inputs: About_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Readme`)
};

const ar_about_heading_label = /** @type {(inputs: About_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعريف`)
};

const bn_about_heading_label = /** @type {(inputs: About_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রিডমি`)
};

const de_about_heading_label = /** @type {(inputs: About_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lies mich`)
};

const es_about_heading_label = /** @type {(inputs: About_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Léame`)
};

const fr_about_heading_label = /** @type {(inputs: About_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lisez-moi`)
};

const pt_about_heading_label = /** @type {(inputs: About_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leia-me`)
};

const zh_about_heading_label = /** @type {(inputs: About_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自述文件`)
};

const tr_about_heading_label = /** @type {(inputs: About_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beni oku`)
};

const ru_about_heading_label = /** @type {(inputs: About_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Файл сведений`)
};

const pl_about_heading_label = /** @type {(inputs: About_Heading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plik Readme`)
};

/**
* | output |
* | --- |
* | "Readme" |
*
* @param {About_Heading_LabelInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const about_heading_label = /** @type {((inputs?: About_Heading_LabelInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Heading_LabelInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_about_heading_label(inputs)
	if (locale === "bn") return bn_about_heading_label(inputs)
	if (locale === "de") return de_about_heading_label(inputs)
	if (locale === "es") return es_about_heading_label(inputs)
	if (locale === "fr") return fr_about_heading_label(inputs)
	if (locale === "pt") return pt_about_heading_label(inputs)
	if (locale === "zh") return zh_about_heading_label(inputs)
	if (locale === "tr") return tr_about_heading_label(inputs)
	if (locale === "ru") return ru_about_heading_label(inputs)
	if (locale === "pl") return pl_about_heading_label(inputs)
	return en_about_heading_label(inputs)
});